(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["article-products"] && !window.DesignMode) return;
  try {
    
  $('.products-carousel').slick({
    slidesToShow: 3.5,
    infinite: false,
    arrows: true,
    adaptiveHeight: true,
    prevArrow:
      '<button type="button" class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><!--!Font Awesome Free 6.5.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z"/></svg></button>',
    nextArrow:
      '<button type="button" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><!--!Font Awesome Free 6.5.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path d="M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z"/></svg></button>',
    responsive: [
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1.1,
          arrows: false,
          adaptiveHeight: false,
          dots: true,
        }
      },
      {
        breakpoint: 900,
        settings: {
          slidesToShow: 2.1,
          arrows: false,
          dots: true,
        },
      },
      {
        breakpoint: 1300,
        settings: {
          slidesToShow: 2.5,
          arrows: false,
          dots: true,
        },
      },
    ],
  });

  $('.products-carousel').find('.slick-prev').hide();

  $('.products-carousel').on('afterChange', function (event, slick, currentSlide) {
    var prevArrow = $(this).find('.slick-prev');
    var nextArrow = $(this).find('.slick-next');
    var slidesToShow = slick.options.slidesToShow;
    var totalSlides = slick.slideCount;
    var slidesRemaining = totalSlides - (currentSlide + slidesToShow);

    if (currentSlide === 0) {
      prevArrow.hide();
    } else {
      prevArrow.show();
    }

    if (slidesRemaining <= 0) {
      nextArrow.hide();
    } else {
      nextArrow.show();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["b2b-header"]) return;
  try {
    

  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["carousel-blog-posts"] && !window.DesignMode) return;
  try {
    
  $('.blog-carousel').slick({
    slidesToShow: 4.3,
    infinite: false,
    arrows: false,
    swipeToSlide: true,
    speed: 200,
    // autoplay: true,
    // autoplaySpeed: 0,
    // speed: 500,
    // pauseOnHover: false,
    // easing: 'linear',
    // draggable: false,
    // swipeToSlide: true,
    // waitForAnimate: false,
    adaptiveHeight: true,
    prevArrow:
      '<button type="button" class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><!--!Font Awesome Free 6.5.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z"/></svg></button>',
    nextArrow:
      '<button type="button" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><!--!Font Awesome Free 6.5.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path d="M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z"/></svg></button>',
    responsive: [
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1.1,
          arrows: false,
          adaptiveHeight: false,
          dots: true,
        },
      },
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 2.1,
          arrows: false,
          dots: true,
        },
      },
      {
        breakpoint: 1370,
        settings: {
          slidesToShow: 3.5,
          arrows: true,
        },
      },
    ],
  });

  $('.blog-carousel').find('.slick-prev').hide();

  // $('.blog-carousel').on('wheel', function (e) {
  //   e.preventDefault();
  //   if (e.originalEvent.deltaY < 0) {
  //     $(this).slick('slickNext');
  //   } else {
  //     $(this).slick('slickPrev');
  //   }
  // });

  $('.blog-carousel').on('afterChange', function (event, slick, currentSlide) {
    var prevArrow = $(this).find('.slick-prev');
    var nextArrow = $(this).find('.slick-next');
    var slidesToShow = slick.options.slidesToShow;
    var totalSlides = slick.slideCount;
    var slidesRemaining = totalSlides - (currentSlide + slidesToShow);

    if (currentSlide === 0) {
      prevArrow.hide();
    } else {
      prevArrow.show();
    }

    if (slidesRemaining <= 0) {
      nextArrow.hide();
    } else {
      nextArrow.show();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["classic-cold"] && !window.DesignMode) return;
  try {
    
    $(document).on('click','span.read_btn',function(){
$(this).closest('.pro_desc-main').find('.des_half').hide();
$(this).closest('.pro_desc-main').find('.des_full').show();
});
$(document).on('click','span.read_less',function(){
$(this).closest('.pro_desc-main').find('.des_half').show();
$(this).closest('.pro_desc-main').find('.des_full').hide();
});  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    

  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["health-carousel"] && !window.DesignMode) return;
  try {
    
  $('.mySwiper3').slick({
    slidesToShow: 3.5,
    infinite: false,
    arrows: true,
    prevArrow:
      '<button type="button" class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><!--!Font Awesome Free 6.5.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z"/></svg></button>',
    nextArrow:
      '<button type="button" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><!--!Font Awesome Free 6.5.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path d="M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z"/></svg></button>',
    responsive: [
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          arrows: true,
          adaptiveHeight: true,
          dots: true,
        },
      },
      {
        breakpoint: 769,
        settings: {
          adaptiveHeight: true,
          slidesToShow: 2.1,
          arrows: true,
          dots: true,
        },
      },
      {
        breakpoint: 1300,
        settings: {
          slidesToShow: 2.5,
          arrows: true,
        },
      },
      {
        breakpoint: 1500,
        settings: {
          slidesToShow: 2.5,
          arrows: true,
        },
      },
      {
        breakpoint: 1900,
        settings: {
          slidesToShow: 3.5,
          arrows: true,
        },
      },
    ],
  });

  $('.mySwiper3').find('.slick-prev').hide();

  $('.mySwiper3').on('afterChange', function (event, slick, currentSlide) {
    var prevArrow = $(this).find('.slick-prev');
    var nextArrow = $(this).find('.slick-next');
    var slidesToShow = slick.options.slidesToShow;
    var totalSlides = slick.slideCount;
    var slidesRemaining = totalSlides - (currentSlide + slidesToShow);

    if (currentSlide === 0) {
      prevArrow.hide();
    } else {
      prevArrow.show();
    }

    if (slidesRemaining <= 0) {
      nextArrow.hide();
    } else {
      nextArrow.show();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-our-community"] && !window.DesignMode) return;
  try {
    
  $(document).ready(function () {
    $('.testimonials-slide').slick({
      slidesToShow: 4.5,
      slidesToScroll: 3,
      infinite: true,
      easing: 'linear',
      autoplay: true,
      autoplaySpeed: 0,
      speed: 8000,
      pauseOnHover: true,
      draggable: true,
      arrows: false,
      swipeToSlide: true, // Enable free mode drag
      responsive: [
        {
          breakpoint: 575,
          settings: {
            arrows: false,
            slidesToShow: 1.1,
          },
        },
        {
          breakpoint: 1800,
          settings: {
            arrows: false,
            slidesToShow: 3.5,
          },
        },
      ],
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["logo-listing"] && !window.DesignMode) return;
  try {
    
   $('.logo-slide').slick({
  centerMode: true,
  centerPadding: '20px',
  slidesToShow: 8,
  margin:10,
   autoplay: true,
  autoplaySpeed: 2000,
   arrows: false,
   dots:false,
  responsive: [
        {
      breakpoint: 1200,
      settings: {
        arrows: false,
        centerMode: true,
        centerPadding: '20px',
        slidesToShow: 3
      }
    },
    {
      breakpoint: 768,
      settings: {
        arrows: false,
        centerMode: true,
        centerPadding: '20px',
        slidesToShow: 4
      }
    },
    {
      breakpoint: 480,
      settings: {
        arrows: false,
        centerMode: true,
        centerPadding: '40px',
        slidesToShow: 3
      }
    }
  ]
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-cold-therapy"] && !window.DesignMode) return;
  try {
    
  $(document).ready(function(){
  $(".benefits-plus").click(function(){
    var index = $(this).data("index");
    $(".the-benefits-box[data-index='" + index + "']").toggleClass("show-overlay");
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-convenient-setup"] && !window.DesignMode) return;
  try {
    
  $(document).ready(function () {
    $('.slider-nav').slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      // asNavFor: '.slider-for',
      dots: true,
      // centerMode: true,
      focusOnSelect: false,
      autoplay: false,
      infinite: false,
      // autoplaySpeed: 2000,
      responsive: [
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 2.3,
          },
        },
        {
          breakpoint: 500,
          settings: {
            slidesToShow: 1.3,
            centerMode: false,
          },
        },
      ],
    });
    // $('.slider-for').slick({
    //   slidesToShow: 1,
    //   slidesToScroll: 1,
    //   arrows: false,
    //   // fade: true,
    //   asNavFor: '.slider-nav',
    // });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-scroll-down"] && !window.DesignMode) return;
  try {
    
  $(document).ready(function() {
     gsap.registerPlugin(ScrollTrigger);

  function setScrollText() {
    gsap.to('#heading1', {
      scrollTrigger: {
        trigger: '#heading1',
        start: '-=1000s', // Adjust the start trigger position
        end: '+=1000s',
        toggleActions: 'play reverse play reverse',
      },
      opacity: 1,
    });

    gsap.to('#heading2', {
      scrollTrigger: {
        trigger: '#heading2',
        start: '+=0s', // Adjust the start trigger position
        end: '+=1000s',
        toggleActions: 'play reverse play reverse',
      },
      opacity: 1,
    });

    gsap.to('#heading3', {
      scrollTrigger: {
        trigger: '#heading3',
        start: '+=1000s', // Adjust the start trigger position
        end: '+=1000s',
        toggleActions: 'play reverse play reverse',
      },
      opacity: 1,
    });
  }
  
  gsap.to('.head', {
    scrollTrigger: {
      trigger: '.head',
      start: 'top top', // Adjust the start trigger position
      end: '+=1500s',
      pin: true,
      pinSpacing: true,
    },
  });

  setScrollText();
  setScrollImages();
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["products-announcement"] && !window.DesignMode) return;
  try {
    
  $(document).ready(function () {
    var element = $('.sticky');
    var visibilityThreshold = 700; // The scroll position at which the element becomes visible

    // Initially hide the element
    element.css({
      visibility: 'hidden',
      width: '100%',
      padding: '20px 0px',
      zIndex: '50',
    });

    $(window).scroll(function () {
      var scrollPosition = $(window).scrollTop();

      if (scrollPosition >= visibilityThreshold) {
        element.css({
          visibility: 'visible',

          zIndex: '50',
        });
      } else {
        element.css({
          visibility: 'hidden',
          width: '100%',
          padding: '20px 0px',
          zIndex: '50',
        });
      }
    });
  });

  jQuery('.page-link').click(function (e) {
    e.preventDefault();
    var menu_height = jQuery('header').outerHeight();
    var href = $(this).attr('href');
    setTimeout(function () {
      $('html,body').animate({ scrollTop: $(href).offset().top - menu_height });
    }, 700);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["products-carousel"] && !window.DesignMode) return;
  try {
    
  $('.products-carousel').slick({
    slidesToShow: 3.5,
    infinite: false,
    arrows: true,
    adaptiveHeight: true,
    prevArrow:
      '<button type="button" class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><!--!Font Awesome Free 6.5.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z"/></svg></button>',
    nextArrow:
      '<button type="button" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><!--!Font Awesome Free 6.5.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path d="M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z"/></svg></button>',
    responsive: [
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1.1,
          arrows: false,
          adaptiveHeight: false,
          dots: true,
        },
      },
      {
        breakpoint: 900,
        settings: {
          slidesToShow: 2.1,
          arrows: false,
          dots: true,
        },
      },
      {
        breakpoint: 1300,
        settings: {
          slidesToShow: 2.5,
          arrows: false,
          dots: true,
        },
      },
    ],
  });

  $('.products-carousel').find('.slick-prev').hide();

  $('.products-carousel').on('afterChange', function (event, slick, currentSlide) {
    var prevArrow = $(this).find('.slick-prev');
    var nextArrow = $(this).find('.slick-next');
    var slidesToShow = slick.options.slidesToShow;
    var totalSlides = slick.slideCount;
    var slidesRemaining = totalSlides - (currentSlide + slidesToShow);

    if (currentSlide === 0) {
      prevArrow.hide();
    } else {
      prevArrow.show();
    }

    if (slidesRemaining <= 0) {
      nextArrow.hide();
    } else {
      nextArrow.show();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials-carousel-global"] && !window.DesignMode) return;
  try {
    
  $(document).ready(function () {
    $('.testimonials-slide-global').slick({
      slidesToShow: 4.5,
      slidesToScroll: 3,
      infinite: true,
      easing: 'linear',
      autoplay: true,
      autoplaySpeed: 0,
      speed: 8000,
      pauseOnHover: true,
      draggable: true,
      arrows: false,
      swipeToSlide: true, // Enable free mode drag
      responsive: [
        {
          breakpoint: 575,
          settings: {
            arrows: false,
            slidesToShow: 1.1,
          },
        },
        {
          breakpoint: 1800,
          settings: {
            arrows: false,
            slidesToShow: 3.5,
          },
        },
      ],
    });
  });

  } catch(e) { console.error(e); }
})();
})();
